/** @jsx jsx */

import React, { cloneElement, Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';
import { useMemo } from 'react';
import { ImageContext } from 'components/lib/Image';
import modalPlaceholderImage from 'assets/CC_Sortation_Placeholder.png';
import imagePlaceholder from 'assets/Long Rectangle.svg';
//Square.png';

const Feedback = props => {
  const { useMediaInFeedback = true, onClose, children } = props;
  let [img, txt, btn] = children;

  const isImg = img?.props?.child === 1;

  let imgSrc;

  if (isImg) {
    imgSrc = img?.props?.children[1]?.props?.src;
  }

  const Img = useMemo(() => {
    return img;
  }, [imgSrc]);

  // </ImageContext.Provider>

  //   ${isImg &&
  //     `
  //   position: relative;
  //   display: flex;
  //   align-items: center;
  // `}

  return (
    <Modal onClose={() => onClose()}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        {useMediaInFeedback && (
          <div
            css={css`
              position: relative;
              width: 100%;

              margin-bottom: 30px;

              .chameleon-image img {
                // max-height: 30vh !important;

                height: auto !important;
                object-fit: contain;
              }

              @media (max-width: 768px) {
                width: 100%;
                margin-bottom: 25px;
              }
            `}
          >
            <ImageContext.Provider
              key={imgSrc}
              value={{
                editWrapperType: 0,
                placeholder: imagePlaceholder || modalPlaceholderImage,
                padding: 10,
              }}
            >
              {Img}
            </ImageContext.Provider>
          </div>
        )}

        <div
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {txt}
        </div>
        <div
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            width: 100%;
          `}
        >
          {window.dev() ? btn : React.cloneElement(btn, { onClick: onClose })}
          {/* {React.cloneElement(btn, { onClick: onClose })} */}
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
